import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/fields/$fieldId/setup/")({
    component: RouteComponent,
});

function RouteComponent() {
    return <div>Hello "/dashboard/fields/$fieldId/setup/"!</div>;
}
